// extracted by mini-css-extract-plugin
export var acceptButton = "_3f-5";
export var fullContent = "_3f-4";
export var link = "_3f-6";
export var linkIcon = "_3f-7";
export var sideContent = "_3f-3";
export var sideImage = "_3f-2";
export var sideImageWrapper = "_3f-1";
export var splitLayout = "_3f-0";